import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';

import { SACT, LACT } from './config';

import { SearchModel } from 'shared/search/search.model';
import { StatusModel } from 'shared/search/status.model';
import { updateActionStatuses } from 'utils/contextual-actions';
import { BrandService } from 'shared/brand/brand.service';
import { ProcessService } from 'shared/process/process.service';
import { PermissionsService } from 'shared/permissions/permissions.service';

@Component({
  moduleId: module.id,
  selector: 'contextual-action',
  templateUrl: 'contextual-action.component.html',
  styleUrls: ['contextual-action.component.scss'],
})
export class ContextualActionComponent {

  @Input() availableStatuses: Array<number> = [];
  @Input() selectedRows: Array<{}> = [];
  @Input() size: number = 0;
  @Input() allSelected: boolean = false;
  @Input() searchModel: SearchModel;
  @Input() statusModel: StatusModel;
  @Input() listFilters: Array<any>;

  @Input() selectedRowsSize: number;
  @Output() actionSelected = new EventEmitter();
  @Output() publish = new EventEmitter();
  @Output() publishConfirmed = new EventEmitter();
  @Output() deleteSelected = new EventEmitter();

  secondaryActions = [
    {
      id: SACT.VIEW_DETAILS.id,
      action: SACT.VIEW_DETAILS.name,
      title: 'View details',
      active: true,
    },
    {
      id: SACT.EDIT_SELECTED.id,
      action: SACT.EDIT_SELECTED.name,
      title: 'Edit selected',
      active: true,
    },
    {
      id: SACT.VIEW_SELECTED.id,
      action: SACT.VIEW_SELECTED.name,
      title: 'View selected',
      active: true,
    },
    {
      id: SACT.BULK_EDIT.id,
      action: SACT.BULK_EDIT.name,
      title: 'Bulk edit',
      active: true,
    },
  ];

  listActions = [
    {
      id: LACT.ADD_TO_LIST.id,
      action: LACT.ADD_TO_LIST.name,
      title: 'Add to list',
      active: false,
    },
    {
      id: LACT.REMOVE_FROM_LIST.id,
      action: LACT.REMOVE_FROM_LIST.name,
      title: 'Remove from list',
      active: false,
    },
  ];

  constructor(
    protected brandService: BrandService,
    protected processService: ProcessService,
    protected permissionsService: PermissionsService,
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get selectedRowsSizeText(): number|string {
    if (this.allSelected) {
      return `about ${this.selectedRowsSize}`;
    } else {
      return this.selectedRowsSize;
    }
  }

  get availableSecondaryActions(): Array<any> {
    if (!this.availableStatuses) { return []; }

    const newActions: any = {};
    if (this.availableStatuses.length === 1) {
      // if only one item selected - "View details" | "Edit selected"
      newActions[SACT.VIEW_DETAILS.name] = true;
      newActions[SACT.EDIT_SELECTED.name] = true;
    } else {
      // if multimle items selected - "View selected" | "Bulk edit"
      newActions[SACT.VIEW_SELECTED.name] = true;
      newActions[SACT.EDIT_SELECTED.name] = true;
    }
    updateActionStatuses(newActions, this.secondaryActions);
    return _.filter(this.secondaryActions, 'active');
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public publishConfirm() {
    const action = 'publish';

     if (this.allSelected) {
       const filter: any = {};
       filter.searchValue = this.searchModel.searchValue;
       filter.status = (this.searchModel.statusModel) ? this.searchModel.statusModel.id.toString() : '';

       this.processService.postStatusUpdateAssets(action, this.brandService.getBrand(), [], filter)
         .subscribe( response => { this.publishConfirmed.emit(); }, error => { this.publishConfirmed.emit(); } );
     } else {
       this.processService.postStatusUpdateAssets(action, this.brandService.getBrand(), _.map(this.selectedRows, '_id'))
         .subscribe( response => { this.publishConfirmed.emit(); }, error => { this.publishConfirmed.emit(); } );
     }
  }

  public hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onSelectedChange(action: any) {
    this.actionSelected.emit(action);
  }

  onPublishClick() {
    this.publish.emit(true);
  }

  onViewDetailsClick() {
    this.actionSelected.emit(this.secondaryActions[0]);
  }

  onAddToListClick() {
    this.actionSelected.emit(this.listActions[0]);
  }

  onRemoveSelectedClick() {
    this.deleteSelected.emit();
  }
}
